export const whyDoYouNeedData = {
  title: 'Why Does Your Company Need Synthetic Data?',
  description: (
    <>
      Let’s face it - your company would probably greatly benefit from using
      synthetic data - you just might not know it yet! Real-world data can be
      costly to obtain, difficult to access, time-consuming to label, and have a
      limited supply, while synthetic datasets can be generated through computer
      simulations or generative models, making them cheaper to produce on demand
      in nearly limitless volumes and customized to an organization's needs.
      Think of it as having a data genie that conjures up exactly what you need,
      whether that's thousands of fraudulent transactions to train your security
      models or patient records that won't land you in regulatory hot water.
      <br />
      <br />
      When information is sparse, synthetic data can fill in the gaps, and it
      can be used to boost data diversity, especially for underrepresented
      groups in AI model training. No more playing the waiting game, no more
      drowning in paperwork for data access approvals, and definitely no more
      compromising your AI's potential because your real dataset looks like
      Swiss cheese. It's like having a cheat code for machine learning, except
      it's totally legal and your compliance team will actually thank you. While
      your competitors are still arguing about data-sharing agreements, you'll
      be shipping AI models that actually work, learning from scenarios that
      haven't even happened yet, and doing it all without exposing a single
      customer's personal information.
    </>
  ),
};
